import styled from "styled-components";

export const StyledCheese = styled.section`
  .price-cheese {
    font-size: 14px;
    color: #749be8;
    font-weight: 700;
    word-spacing: 2px;
    margin-left: 5px;
  }
`;
